import React, {useCallback, useEffect, useMemo} from 'react';
import {useInjectSaga} from 'utils/injectSaga';
import companySaga from 'sagas/companySaga';
import teamSaga from 'sagas/teamSaga';
import rolesSaga from 'sagas/rolesSaga';
import {fetchCountries} from 'actions/companyActions';
import {fetchRoles} from 'actions/rolesAction';
import {useDispatch, useSelector} from 'react-redux';
import {
  createUpdateTeam,
  getStaff,
  getTeamMembers,
  updateStatus,
} from 'actions/teamActions';

import Table from './Table';

export default () => {
  const dispatch = useDispatch();
  useInjectSaga({key: 'company', saga: companySaga});
  useInjectSaga({key: 'team', saga: teamSaga});
  useInjectSaga({key: 'role', saga: rolesSaga});
  const roles = useSelector((state) => state.roles.roles);
  const targetRole = roles.find((role) => role.title === 'admin');
  useEffect(() => {
    getItems();
    dispatch(getStaff());
    dispatch(fetchCountries());
    dispatch(fetchRoles());
  }, []);

  const team = useSelector((state) => state.team);
  const {teams} = team;

  const createUpdateStatus = useMemo(
    () => ({
      submitting: team.submitting,
      createSuccess: team.createSuccess,
      createFailed: team.createFailed,
      error: team.statusText,
      id: team.itemId,
    }),
    [team]
  );

  const createUpdateItem = useCallback((item) => {
    dispatch(createUpdateTeam(item._id, item, 'admin'));
  }, []);

  const getItems = useCallback(() => {
    dispatch(getTeamMembers('admin'));
    dispatch(updateStatus());
  }, []);

  return (
    <>
      {teams?.map((team, i) => (
        <Table
          key={team._id}
          team={team}
          index={i}
          createUpdateItem={createUpdateItem}
          getItems={getItems}
          targetRole={targetRole}
          createUpdateStatus={createUpdateStatus}
        />
      ))}
    </>
  );
};
